/**
 * @module AuroraMobileSearch
 * @description Singleton module that manages the mobile search toggle behavior.
 * @author Simon Agadzhanov
 */
const AuroraMobileSearch = (function () {
  /**
   * An object representing the module's settings.
   *
   * @private
   * @type {object} SETTINGS
   */
  const SETTINGS = {
    name: "aurora-mobile-search.js",
    debugging: true,
  };

  /**
   * Cached DOM elements used by the module.
   *
   * @private
   * @type {Object<string, HTMLElement>} ELEMENTS
   */
  const ELEMENTS = {
    toggleBtn: document.querySelector(".js--toggle-mobile-search"),
    overlay: document.querySelector(".js--mobile-search-overlay"),
    closeBtn: document.querySelector(".js--mobile-search-close"),
  };

  /**
   * Initializes the module.
   *
   * @public
   * @function init
   */
  const init = function () {
    if (SETTINGS.debugging) console.log(`${SETTINGS.name} :: Start`);

    if (ELEMENTS.toggleBtn && ELEMENTS.overlay && ELEMENTS.closeBtn) {
      setupEvents();
    } else if (SETTINGS.debugging) {
      console.warn(`${SETTINGS.name} :: Missing DOM elements`);
    }

    if (SETTINGS.debugging) console.log(`${SETTINGS.name} :: Complete`);
  };

  /**
   * Sets up event listeners for toggling and closing the mobile search overlay.
   *
   * @private
   * @function setupEvents
   */
  const setupEvents = function () {
    const { toggleBtn, overlay, closeBtn } = ELEMENTS;

    toggleBtn.addEventListener("click", () => {
      overlay.classList.add("active");
    });

    closeBtn.addEventListener("click", () => {
      overlay.classList.remove("active");
    });

    overlay.addEventListener("click", (e) => {
      if (e.target === overlay) overlay.classList.remove("active");
    });
  };

  // Reveal public methods
  return {
    init,
    SETTINGS,
  };
})();
